import React from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import { Home, ArrowRight } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { resolveLegacyRedirect } from '../data/legacyRedirects';

export default function NotFoundPage() {
  const { pathname } = useLocation();
  const redirect = resolveLegacyRedirect(pathname);
  if (redirect) return <Navigate to={redirect} replace />;
  return (
    <div className="pt-0 lg:pt-28 min-h-[70vh] bg-gray-50 flex items-center">
      <Helmet>
        <title>Page Not Found | Imprint MIS</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="section-container text-center py-24" data-testid="not-found-page">
        <p
          className="text-[10px] font-semibold uppercase tracking-[3px] text-[#00BCE4] mb-4"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          404 — Page Not Found
        </p>
        <h1
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Looks like this page went <span className="text-[#00BCE4]">off-press</span>
        </h1>
        <p
          className="text-lg text-gray-600 mb-10 max-w-xl mx-auto"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          The page you&apos;re looking for doesn&apos;t exist or may have moved.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link to="/" data-testid="not-found-home-link" className="btn-primary text-xs">
            <Home size={16} /> Back to Home
          </Link>
          <Link
            to="/#contact"
            data-testid="not-found-contact-link"
            className="inline-flex items-center gap-2 text-sm font-semibold text-gray-600 hover:text-[#00BCE4] transition-colors"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Contact Us <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
}
